import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'provider',
    'practicesProvider',
    'switcher',
    'providerSource',
    'providerFirstName',
    'providerLastName',
    'providerMiddleName',
  ];

  switchSelect() {
    this.providerTarget.classList.toggle('d-none');
    this.practicesProviderTarget.classList.toggle('d-none');

    // switch provider source
    if (this.providerSourceTarget.value === 'npi_search') {
      this.providerSourceTarget.value = 'practice';
    } else if (this.providerSourceTarget.value === 'practice') {
      this.providerSourceTarget.value = 'npi_search';
    }
  }

  handleProviderSelect(event) {
    const option = event.detail.target;
    this.setProviderValues(option);
  }

  /**
   * @private
   */
  setProviderValues(option) {
    const { firstName, middleName, lastName } = option.dataset;

    this.providerFirstNameTarget.value = firstName || '';
    this.providerLastNameTarget.value = lastName || '';
    this.providerMiddleNameTarget.value = middleName || '';
  }
}
